import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ApplicationUser} from "../services/ApplicationUser";
import {RoleTypes} from "../models/roles";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private appUser: ApplicationUser) { }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): boolean {
        const appUser = this.appUser;

        let roles = !route.data["roles"] ? [] : route.data["roles"] as Array<RoleTypes>;
        let permissions = !route.data["permissions"] ? [] : route.data["permissions"] as Array<string>;

        if (!appUser.loggedIN) {
            this.router.navigate(['/login']);
            return false;
        }

        if (roles.length) {
            if (!appUser.hasRole(roles)) {
                this.router.navigate(['/']);
                return false;
            }
        }

        if (permissions.length) {
            if (!appUser.user.permissions) {
                this.router.navigate(['/']);
                return false;
            }

            let hasPermission = false;
            for(let i in permissions) {
                if (appUser.user.permissions.indexOf(permissions[i]) > -1) hasPermission = true;
            }

            if (!hasPermission) {
                this.router.navigate(['/']);
                return false;
            }

        }

        return true
    }
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts